import { SettingsSystemTab } from "@/components/settings/SettingsSystemTab";

export function SettingsSystemPage() {
  return <SettingsSystemTab />;
}
